import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/authStore";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const { user, resetPassword } = useAuth();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (p1 !== p2) {
      setErr("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await resetPassword(p1);
      navigate("/focus", { replace: true });
    } catch (e2) {
      const detail = e2?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-page" data-testid="reset-page">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <div className="brand-mark">∞</div>
          <div>
            <div className="wordmark" style={{ fontSize: 22 }}>
              Command<span className="linc">Linc</span>
            </div>
            <div className="hint" style={{ marginTop: 2 }}>Forced password reset</div>
          </div>
        </div>
        <div className="tag">First-login security check</div>
        <h1>Set a new password</h1>
        <p className="sub-tag">
          Signed in as <b>{user?.email}</b>. Choose a password with ≥12 characters, mixing
          upper, lower, digit and symbol.
        </p>

        {err ? <div className="auth-error" data-testid="reset-error">{err}</div> : null}

        <div className="form-row">
          <label htmlFor="p1">New password</label>
          <input
            id="p1"
            type="password"
            data-testid="reset-new"
            value={p1}
            onChange={(e) => setP1(e.target.value)}
            required
            minLength={12}
          />
        </div>
        <div className="form-row">
          <label htmlFor="p2">Confirm password</label>
          <input
            id="p2"
            type="password"
            data-testid="reset-confirm"
            value={p2}
            onChange={(e) => setP2(e.target.value)}
            required
            minLength={12}
          />
        </div>

        <button
          type="submit"
          className="btn primary"
          data-testid="reset-submit"
          style={{ width: "100%", justifyContent: "center", marginTop: 6 }}
          disabled={busy}
        >
          {busy ? <span className="loader" /> : "Update password & continue"}
        </button>
      </form>
    </div>
  );
}
